module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1243.a9db1b97.png";